import { cacheDom } from "../utils/QuerySelectors.js"

const dom = {}
const qs = {
  alert: 'data-alert-message',
}

const qsAll = {
}
const hideMessage = () => {
  dom.alert.classList.add('opacity-0', '-z-1')
  dom.alert.classList.remove('z-[100002]')
  dom.alert.setAttribute('aria-hidden', true)
  dom.alert.removeAttribute('tabindex')
  dom.alert.innerHTML = ''
}

const showMessage = (text, actionElement = null) => {
  dom.alert.innerHTML = text
  dom.alert.classList.remove('opacity-0', '-z-1')
  dom.alert.classList.add('z-[100002]')
  dom.alert.setAttribute('aria-hidden', false)
  dom.alert.setAttribute('tabindex', 0)
  dom.alert.focus()
  setTimeout(() => {
    hideMessage()
  }, 5000)
  if(actionElement) {
    const originLabel = actionElement.getAttribute('aria-label')
    actionElement.setAttribute('aria-label', text)
    actionElement.focus()
    setTimeout(() => {
      if(originLabel)
        actionElement.setAttribute('aria-label', originLabel)
      else
        actionElement.removeAttribute('aria-label')
    }, 500)
  }
}

window.showCustomMessage = showMessage
window.hideCustomMessage = hideMessage

export const setupAlertMessage = () => {
  cacheDom(dom, qs, qsAll)
  if(dom.alert) {
    const searchParams = new URLSearchParams(location.search)
    if(searchParams.get('account_created') && searchParams.get('account_created') == 'true' && !!window.shopifyCustomer && !location.href.includes('/register')) {
      showMessage('Account created successfully')
    }
  }
}